/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRoundedCornersTopR = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path d="M12.5 6a7 7 0 0 1 7 7v7h2v-7a9 9 0 0 0-9-9h-7v2z" fill="currentcolor" />
    </g>
  </Icon>
);
export { SvgRoundedCornersTopR as RoundedCornersTopR };
